import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { ActionButton, UrlButton } from "../buttons";
import { mainMenu } from "../../constants";
import MenuIcon from "../../icons/menu";
import ExitIcon from "../../icons/menu";
import UserProfileMenuWidget from "../profile/profileWidget";
import { backend } from "../../services/backend";
import { hasCommonElement, isTabActive } from "../../utils";

/* 
1	1	"Просмотр событий группы"
2	1	"Просмотр всех событий"
3	1	"Назначение ответственных по событиям группы"
4	1	"Назначение ответственных по всем событиям"
5	2	"Просмотр задач группы"
6	2	"Просмотр всех задач"
7	2	"Редактирование задач группы"
8	2	"Редактирование всех задач"
9	2	"Создание задач"
10	3	"Просмотр клиентов группы"
11	3	"Просмотр всех клиентов"
12	3	"Создание клиентов"
13	3	"Редактирование клиентов группы"
14	3	"Редактирование всех клиентов"
15	3	"Редактирование источников клиентов"
16	3	"Установление плана продаж внутри группы"
17	3	"Установление плана продаж для группы"
18	6	"Создание и удаление приглашений для своей группы"
19	4	"Просмотр аналитики группы"
20	4	"Просмотр аналитики всей"
21	5	"Просмотр профилей пользователей в группе"
22	5	"Добавление пользователей"
23	5	"Блокирование пользователей"
24	6	"Создание и редактирование групп пользователей"
25	6	"Создание и удаление приглашений по всем группам"
26	7	"Создание и редактирование ролей"
27 5  "Просмотр списка пользователей своей группы"
*/

export const AppMainMenu = () => {

  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const logoutAction = () => {
    backend
      .signout()
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setTimeout(() => {
          document.location.pathname = "/";
        }, 1000);
      });
  };

  const isMenuHidden = State.menuHidden;

  const hideMenu = (val = false) => {
    dispatch(actions.hideMenu(val))
  }

  const rights = State.rights;

  return (
    <div 
    className={`header mainMenu${isMenuHidden? " sided" : ""}`}
    onMouseOver={hideMenu.bind(this, false)}
    onMouseOut={hideMenu.bind(this, true)}>
      <div className="inner menuHeaderInner">
        <div className="flex menuHeader">
          <p>CRM</p>
          {/* <MenuIcon width={28} height={28} /> */}
        </div>
      </div>
      <div className="inner menuContentInner">
        <div className="topContentInner">
          <div className="menuSectionTop menuTopContent">
            {mainMenu.map((item, index) => {
              const isActive = isTabActive(item.url);
              if (!rights.rang || rights.rang > 2) {
                // Проверка прав на доступ к вкладкам
                if (index === 5 && (!hasCommonElement(rights.permissions, [18, 21, 22, 25]))) {
                  return null;
                }
                if (index === 6 && !hasCommonElement(rights.permissions, [24])) {
                  return null;
                }
                if (index === 7 && !hasCommonElement(rights.permissions, [26])) {
                  return null;
                }
              }
              return (
                <div key={`mmbtn${index * 1.014}`}>
                  <UrlButton
                    icon={item.icon}
                    text={item.name}
                    url={item.url}
                    classNames={["mainMenuItem"]}
                  />
                  {isActive && item.submenu?.map((item, subindex) => {
                    if (rights.rang > 2) {
                      if (index === 5 && !hasCommonElement(rights.permissions, [18, 20])) {
                          return null;
                      }
                      if (index === 4 && subindex === 2 && !hasCommonElement(rights.permissions, [20])) {
                        return null;
                      }
                    }
                    return <div key={`submm${subindex}`}>
                      <UrlButton
                         icon={item.icon}
                         text={item.name}
                         url={item.url}
                         classNames={["mainMenuItem"]}
                         isSubmenu={true}
                      />
                    </div>
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div className="bottomContentInner">
          <div className="smallInner menuBottomContent">
            <ActionButton
              icon={<ExitIcon width={20} height={20} />}
              text={"Выйти"}
              classNames={["mainMenuItem"]}
              action={logoutAction}
            />
            <UserProfileMenuWidget />
          </div>
        </div>
      </div>
    </div>
  );
};
